export default "__VITE_ASSET__BCshwKsh__"